import React, { Children, PureComponent, PropTypes } from 'react';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { ListItem, ListItemText } from '@catalytic/pushbot-ui/List';
import { getFilters, deleteFilter } from '../actions/api/filter';
import { filtersList } from '../selectors/entities';
import { teamName, username } from '../selectors/session';
import { filter as filterPropType } from '../types/api';

/**
 * Takes a list of filter shapes and renders them as FilterListItems
 */
export const createFilterListItemSelector = filterListSelector =>
  createSelector(
    filterListSelector,
    (state, props = {}) => props.className,
    (state, props = {}) => props.onClick,
    (filters = [], className, onClick) =>
      Children.map(
        filters.map((filter, i) => {
          const { name, query } = filter;
          const href = `/search?q=${encodeURIComponent(query)}`;
          return (
            // eslint-disable-next-line react/jsx-key
            <ListItem
              margin={i === filters.length - 1}
              {...{ href, className, onClick }}
            >
              <ListItemText inherit noWrap primary={name} />
            </ListItem>
          );
        }),
        React.cloneElement
      )
  );

export class FilterListContainer extends PureComponent {
  static displayName = 'FilterListContainer';

  static propTypes = {
    /**
     * Class to apply to the menu items in the filter list
     */
    className: PropTypes.string,
    /**
     * Action to delete a filter via the API.
     */
    deleteFilter: PropTypes.func,
    /**
     * A list of filters in the system, populates the menu items in the filter list
     */
    filters: PropTypes.arrayOf(filterPropType),
    /**
     * Action to list filters via the API.
     */
    getFilters: PropTypes.func,
    /**
     * Current team name.
     */
    teamName: PropTypes.string,
    /**
     * Current authed user's username.
     */
    username: PropTypes.string,
    /**
     * ListItem child nodes
     */
    filterListItems: PropTypes.node
  };

  componentDidMount() {
    const { getFilters, teamName, username } = this.props;
    getFilters({ teamName, username });
  }

  render() {
    return <div>{this.props.filterListItems}</div>;
  }
}

const mapStateToProps = (state, props) => ({
  filterListItems: createFilterListItemSelector(filtersList)(state, props),
  teamName: teamName(state),
  username: username(state)
});

const mapDispatchToProps = {
  getFilters,
  deleteFilter
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterListContainer);



// WEBPACK FOOTER //
// ./js/Search/FilterListContainer.js